import React from 'react';
import { Dialog, BUTTON_VARIANTS } from 'cdk-radial';

const ACH_TERMS_TEXT =
  'By accepting, you authorize CDK Global to debit your designated bank account for charges related to its services and products until this authorization is revoked. Changes or cancellations to the existing account will be effective from next billing cycle.';

export const ACHMandateDialog = ({ isOpen, onAccept, onDecline }) => {
  return (
    <Dialog
      buttonsProps={[
        {
          id: 'ach-terms-decline-button',
          onClick: onDecline,
          text: 'Decline',
          variant: BUTTON_VARIANTS.TEXT
        },
        {
          id: 'ach-terms-accept-button',
          onClick: onAccept,
          text: 'Accept',
          variant: BUTTON_VARIANTS.PRIMARY
        }
      ]}
      id="ach-terms-dialog"
      isOpen={isOpen}
      onClose={onDecline}
      style={{ maxWidth: '560px' }}
      title="Bank Account Authorization"
    >
      {ACH_TERMS_TEXT}
    </Dialog>
  );
};
